import { z } from 'zod';
import { BibleLocationSchema } from '../bible/bible-location.js';
import { StudentSchema } from './student.js';
import { TeacherSchema } from './teacher.js';
/**
 * Study group schema - a reusable group of students and teachers
 */
export const StudyGroupSchema = z.object({
    id: z.string(),
    name: z.string().min(1),
    description: z.string().optional(),
    leaderCount: z.number().int().nonnegative().default(1),
    students: z.array(StudentSchema),
    teachers: z.array(TeacherSchema).default([]),
    lastUsedAt: z.string().optional(),
    updatedAt: z.string().optional(),
    memoryStartingLocation: BibleLocationSchema.optional(),
    memoryEndingLocation: BibleLocationSchema.optional(),
});
/**
 * Options for creating a new study group
 */
export const StudyGroupAddOptionsSchema = z.object({
    name: z.string().min(1),
    description: z.string().optional(),
    leaderCount: z.number().int().nonnegative().optional(),
});
//# sourceMappingURL=study-group.js.map